import {BoltRuntimes} from './BoltRuntimes'
import {runtime as viewerManagerRuntime} from 'bolt-ds-viewer-manager-amd'

export const DsRuntimes = [
    ...Object.values(viewerManagerRuntime),
    ...Object.values(BoltRuntimes)
]
